import React from 'react'
import DownloadPage from './DownloadPage'

export default function AssertivelyCharmingWorkshopNotes() {
    return (

        <DownloadPage url="/resourcesforpublic/CharminglyAssertiveWorkshopNotes.pdf" text="How To Be Charmingly Assertive" />
    )
}
